module.exports = __webpack_public_path__ + "static/wombatmain-3caa31d2a3fec4f537482f99a8169a42.png";